import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { Message } from "./Message";

var ToastManager =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToastManager, _React$Component);

  function ToastManager(props) {
    var _this;

    _classCallCheck(this, ToastManager);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToastManager).call(this, props));
    _this.state = {
      "top-left": [],
      top: [],
      "top-right": [],
      "bottom-left": [],
      bottom: [],
      "bottom-right": []
    };

    _this.notify = function (message, options) {
      var toast = _this.createToastState(message, options);

      var position = toast.position; // prepend the toast for toasts positioned at the top of
      // the screen, otherwise append it.

      var isTop = position.includes("top");

      _this.setState(function (prev) {
        return Object.assign({}, prev, _defineProperty({}, position, isTop ? [toast].concat(_toConsumableArray(prev[position])) : [].concat(_toConsumableArray(prev[position]), [toast])));
      });
    };

    _this.createToastState = function (message, options) {
      var id = ++ToastManager.idCounter; // a bit messy, but object.position returns a number because
      // it's a method argument.

      var position = options.hasOwnProperty("position") && typeof options.position === "string" ? options.position : "top";
      return {
        id: id,
        message: message,
        position: position,
        showing: true,
        duration: typeof options.duration === "undefined" ? 5000 : options.duration,
        onRequestRemove: function onRequestRemove() {
          return _this.removeToast(String(id), position);
        },
        type: options.type
      };
    }; // actually fully remove the toast


    _this.removeToast = function (id, position) {
      _this.setState(function (prev) {
        return Object.assign({}, prev, _defineProperty({}, position, prev[position].filter(function (toast) {
          return toast.id !== id;
        })));
      });
    };

    props.notify(_this.notify);
    return _this;
  }

  _createClass(ToastManager, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return Object.keys(this.state).map(function (position) {
        var p = position;
        var toasts = _this2.state[p];
        return React.createElement("span", {
          key: position,
          className: "Toaster__manager-" + position
        }, toasts.map(function (toast) {
          return React.createElement(Message, Object.assign({
            position: p,
            key: toast.id
          }, toast));
        }));
      });
    }
  }]);

  return ToastManager;
}(React.Component);

export { ToastManager as default };
ToastManager.idCounter = 0;